// Helper function to determine if object is a folder
export const isFolder = (key: string): boolean => {
    return key.endsWith('/')
}

export const getFileName = (key: string): string => {
    return key.split('/').pop() || key
}

export const extractObjectName = (prefix: string): string => {
    return prefix.split('/').filter(Boolean).pop() || ''
}
